export enum Privilege {
  ReadOpportunities = 'opportunities.read',
  ReadKnowledgebase = 'knowledgebase.read',
  UpdateKnowledgebase = 'knowledgebase.update',
  ReadApollo = 'Apollo.read',
  UpdateApollo = 'Apollo.update',
  ReadDashboard = 'dashboards.read',
  DownloadDashboard = 'dashboards.download',
  ReadInitiatives = 'initiatives.read',
  ReadInternalOnly = 'internal-only.read',
  UpdateInternalOnly = 'internal-only.update',
  SwitchUsers = 'admin.switchUsers',
  ReadEcho = 'echo.read',
  ReadRisk = 'risk.read',
  ReadPHI = 'phi.read',
  ReadAdmin = 'admin.read',
  ReadInternalRoles = 'admin.readInternalRoles',
  ReadLifeline = 'lifeline.read',
  ReadStrategyBoard = 'strategyboard.read',
  ReadTemplates = 'templates.read',
  UpdateTemplates = 'templates.update',
  ReadFrontdoor = 'frontdoor.read',
  ReadVirtualAnalyst = 'virtualanalyst.read',
  ReadReportBuilder = 'reportbuilder.read',
  ReadBVA = 'bva.read',
  ReadProAxysWorkflow = 'proaxys-workflow.read',
  UpdateStrategyBoard = 'strategyboard.update',
  ReadTenantOffboarding = 'tenant-offboarding.read',
  RequestTenantOffboarding = 'tenant-offboarding.request',
  ApproveTenantOffboarding = 'tenant-offboarding.approve',
}
export enum PolicyEffect {
  Allow = 'allow',
  Deny = 'deny',
}
